<template>
  <section>
    <social-header v-if="currentEnv" title="结算记录"></social-header>
    <!--头部-->
    <div class="search" style="position: relative; z-index: 999">
      <van-search
        v-model="matchingFields"
        show-action
        ref="search"
        placeholder="请输入业务订单号搜索"
      >
        <template #action>
          <div
            class="search-cancel"
            v-show="isShowSearchCancel"
            @click.self="reset"
          >
            取消
          </div>
          <div
            class="search-confirm"
            v-show="!isShowSearchCancel"
            @click="searchHandle"
          >
            搜索
          </div>
        </template></van-search
      >
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" @load="onLoad">
        <div class="withdraw" v-if="list.length > 0">
          <ul class="withdraw-list">
            <li
              class="withdraw-list-item"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="activity-name">
                <div class="left">业务订单号</div>
                <div class="right">{{ item.orderId }}</div>
              </div>
              <div class="order-no">
                <div class="left">业务线</div>
                <div class="right">{{ item.businessLineName }}</div>
              </div>
              <div class="order-no">
                <div class="left">奖励节点</div>
                <div class="right">{{ item.orderNodeName }}</div>
              </div>
              <div class="withdraw-price">
                <div class="left">奖励对象</div>
                <div class="right">{{ item.beneficiaryName }}</div>
              </div>
              <div class="award-state">
                <div class="left">奖励金额</div>
                <div class="right">￥{{ item.aftertaxAmount }}</div>
              </div>
              <div class="award-type">
                <div class="left">结算时间</div>
                <div class="right">{{ item.settlementTime }}</div>
              </div>
            </li>
          </ul>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-empty v-show="list.length == 0" description="暂无结算记录" />
    <social-dialog
      title="正在加载"
      category="tips"
      v-bind:show="dialogShow"
    ></social-dialog>
    <!--我的订单-->
  </section>
</template>

<script>
import SocialHeader from "../../components/social-header.vue";
import SocialDialog from "../../components/social-dialog.vue";
import orderApi from "../../api/order.js";
import {
  isWeiXin,
  isDingDing,
  changeDocumentTitle,
} from "../../service/environment";

export default {
  components: {
    SocialHeader,
    SocialDialog,
  },
  name: "SettlementList",
  data: function () {
    return {
      dialogShow: false,
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      matchingFields: "", // 查询订单id
      isShowSearchCancel: false, // 是否显示搜索取消按钮
      pageNo: 1,
    };
  },
  created: function () {
    changeDocumentTitle("结算记录");
  },
  computed: {
    currentEnv() {
      if (isWeiXin()) {
        return false;
      } else if (isDingDing()) {
        return false;
      } else {
        return true;
      }
    },
    userINFO() {
      return JSON.parse(localStorage.getItem("USER_INFO"));
    },
  },
  methods: {
    searchHandle() {
      if (this.matchingFields == "") {
        this.$toast({
          message: "请输入业务订单号",
          duration: 1500,
        });
        return;
      }

      this.list = [];
      this.pageNo = 1;
      this.finished = false;
      this.onLoad();
      this.isShowSearchCancel = true;
    },
    // 重置搜索订单id
    reset() {
      this.list = [];
      this.matchingFields = "";
      this.pageNo = 1;
      this.finished = false;
      this.onLoad();
      this.isShowSearchCancel = false;
    },
    async onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.pageNo = 1;
        this.refreshing = false;
      }

      this.loading = true;
      this.dialogShow = true;
      const params = {
        PlatformAgentID: this.userINFO.platformAgentID,
        pageNo: this.pageNo,
        matchingFields: this.matchingFields,
      };

      try {
        let res = await orderApi.getSettlementList(params);
        if (res.data.returnCode == 0) {
          if (this.refreshing) {
            this.list = [];
          }
          this.list = this.list.concat(res.data.result.list);
          this.pageNo += 1;

          if (this.list.length >= res.data.result.total) {
            this.finished = true;
          }
        } else {
          this.list = [];
          this.finished = true;
          this.$toast({
            message: res.data.message,
            duration: 1500,
          });
        }
      } catch (error) {
        console.log("---->", error);
      } finally {
        this.dialogShow = false;
        this.loading = false;
      }
    },
    onRefresh() {
      this.finished = false;
      this.onLoad();
    },
  },
};
</script>
<style scoped>
.withdraw {
  width: 100%;
  min-height: 100%;
  height: auto;
  position: relative;
}
.withdraw-list {
  width: 100%;
  padding: 1.25rem 0.875rem;
  box-sizing: border-box;
  overflow: auto;
}
.withdraw-list-item {
  width: 100%;
  margin-bottom: 0.75rem;
  padding: 1.25rem 1.0625rem;
  background-color: #fff;
  border-radius: 0.75rem;
  box-sizing: border-box;
}
.withdraw-list-item .activity-name,
.order-no,
.withdraw-price,
.award-state,
.award-type,
.award-time {
  display: flex;
  font-size: 0.875rem;
  height: 1.875rem;
  align-items: center;
  color: #777;
}
.withdraw-list-item .activity-name .left,
.withdraw-list-item .order-no .left,
.withdraw-list-item .withdraw-price .left,
.withdraw-list-item .award-state .left,
.withdraw-list-item .award-type .left,
.withdraw-list-item .award-time .left {
  color: rgb(17, 30, 54);
  width: 7.5rem;
  flex-shrink: 0;
}
.withdraw-list-item .activity-name .right,
.withdraw-list-item .order-no .right,
.withdraw-list-item .withdraw-price .right,
.withdraw-list-item .award-state .right,
.withdraw-list-item .award-type .right,
.withdraw-list-item .award-time .right {
  width: 100%;
  text-align: right;
}
.withdraw-list-item .withdraw-price .right {
  color: rgb(45, 117, 255);
}
</style>



// WEBPACK FOOTER //
// src/pages/account/settlement.vue